module.exports = __webpack_public_path__ + "media/images/product/f_l-01d2a0fc6b115d1b0437b8b1247e3428.png";